import { render, staticRenderFns } from "./TestInvoices.vue?vue&type=template&id=4808a382"
import script from "./TestInvoices.vue?vue&type=script&lang=js"
export * from "./TestInvoices.vue?vue&type=script&lang=js"
import style0 from "./TestInvoices.vue?vue&type=style&index=0&id=4808a382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports